<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-calendar`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3a1 1 0 011 1v2h16V4a1 1 0 011-1h2a1 1 0 011 1v2h6c1.105 0 2 .945 2 2.111V41.89C44 43.055 43.105 44 42 44H6c-1.105 0-2-.945-2-2.111V8.11C4 6.945 4.895 6 6 6h5.999L12 4a1 1 0 011-1h2zm25 21H8v16h32V24zM11.999 10H8v10h32V10h-4v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2H16v2a1 1 0 01-1 1h-2a1 1 0 01-1-1l-.001-2z"/></svg>
</template>
<script>

export default {
  name: 'IconCalendar',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
